// slightly modified/simplified version of underscore.js's throttle (v1.8.3)
export function throttle (func, wait) {
  var timeout = null
  var previous = 0
  var later = function () {
    previous = Date.now()
    timeout = null
    func()
  }
  return function () {
    var now = Date.now()
    var remaining
    if (!previous) previous = now
    remaining = wait - (now - previous)
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout)
        timeout = null
      }
      previous = now
      func()
    } else if (!timeout) {
      timeout = setTimeout(later, remaining)
    }
  }
}



// WEBPACK FOOTER //
// ./client/utils/throttle.js